import apiClient from '@/services/api';
import { USER_DEPOTS_PATH } from './constants';
import type { Depot } from './types';

export const useUserDepotsApi = () => {
  const getMyDepots = async () => {
    const { data } = await apiClient.get<Depot[]>(USER_DEPOTS_PATH);
    return data;
  };

  return {
    getMyDepots
  };
};
